
































































































































































import { Component, Vue } from "vue-property-decorator";
import sidebar from "@/components/englishjanala/sidebar.vue";
import ConversationIcon from "@/components/svgicon/ConversationSVG.vue";
import WordsIcon from "@/components/svgicon/WordsSVG.vue";
import GrammarIcon from "@/components/svgicon/GrammarSVG.vue";
import HeadphonSVG from "@/components/svgicon/HeadphonSVG.vue";
// import { Chapter } from "@/model/englishjanala/englishjanala.ts";
import * as data from "@/model/englishjanala/englishjanala.json";

@Component({
  components: {
    sidebar,
    ConversationIcon,
    WordsIcon,
    GrammarIcon,
    HeadphonSVG,
  },
})
export default class SubCategory extends Vue {
  Count: string = localStorage.getItem("UserLoggedIn");
  currentRouteName = "";
  currentPath = "";

  SignOut() {
    import("@/plugins/google-oauth2").then(async () => {
      while (!this.$gAuth.isInit) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
    });
    this.$gAuth.signOut();
    localStorage.setItem("UserLoggedIn", "false");
    this.$router.push({ name: "main.login_page" });
    localStorage.removeItem("profileImageUrl");
    location.reload();
  }

  mounted() {
    this.currentRouteName = this.$route.name;
    this.currentPath = this.$route.path;
  }
  CheckUrl(SubString: any) {
    return this.currentPath.includes(SubString);
  }
  get ProfileImage() {
    return localStorage.getItem("profileImageUrl");
  }
}
